import apiClient from './client';

export interface CustomerCompact {
  id: string;
  ragione_sociale: string;
  piva: string | null;
  codice_fiscale: string | null;
  sede_legale: string | null;
  referente: string | null;
  telefono: string | null;
  email: string | null;
  pec: string | null;
}

export async function searchCustomers(search: string, limit = 10): Promise<CustomerCompact[]> {
  const { data } = await apiClient.get<{ items: CustomerCompact[] }>('/api/customers', {
    params: { search, limit },
  });
  return data.items;
}
